var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWarningCheck = function SvgWarningCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57.479,
    height: 51.164,
    viewBox: "0 0 57.479 51.164",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18272",
    "data-name": "Group 18272",
    transform: "translate(-64.033 -573.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M46.211,28.221a6.69,6.69,0,0,1,0-5.192l.233-.547a6.8,6.8,0,0,0-3.775-8.927l-.513-.228a6.748,6.748,0,0,1-3.775-3.689L38.2,9.184a7.163,7.163,0,0,0-9.18-3.689l-.466.182a7.262,7.262,0,0,1-5.359,0l-.419-.182a7.094,7.094,0,0,0-9.087,3.735l-.186.364a6.748,6.748,0,0,1-3.775,3.689l-.419.182a6.813,6.813,0,0,0-3.728,8.927l.186.41a6.69,6.69,0,0,1,0,5.192l-.186.5a6.7,6.7,0,0,0,3.775,8.881l.466.182a6.748,6.748,0,0,1,3.775,3.689l.233.5a7.02,7.02,0,0,0,9.087,3.735l.513-.228a7.262,7.262,0,0,1,5.359,0l.419.182a7.069,7.069,0,0,0,9.133-3.689l.186-.364A6.748,6.748,0,0,1,42.3,37.694l.373-.137a6.744,6.744,0,0,0,3.775-8.927ZM24.03,34.37h0L14.943,26.9l2.8-3.234,5.778,4.782L33.723,16.607l3.309,2.733-13,15.03Z",
    transform: "translate(59 579.012)",
    fill: "#ff6a65"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Warning_911852",
    transform: "translate(316.445 758.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17741",
    "data-name": "Group 17741",
    transform: "translate(-214.997 -185.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17740",
    "data-name": "Group 17740",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10800",
    "data-name": "Path 10800",
    d: "M10.037,0A1.553,1.553,0,0,0,8.728.679L.213,13.787a1.233,1.233,0,0,0,0,1.374,1.549,1.549,0,0,0,1.317.679H18.544a1.549,1.549,0,0,0,1.317-.679,1.248,1.248,0,0,0,0-1.374L11.346.679A1.553,1.553,0,0,0,10.037,0Zm0,.834a.677.677,0,0,1,.525.266l8.515,13.115a.5.5,0,0,1,0,.517.7.7,0,0,1-.533.273H1.53A.687.687,0,0,1,1,14.732a.5.5,0,0,1,0-.517L9.512,1.1A.677.677,0,0,1,10.037.834Zm0,3.545a.441.441,0,0,0-.46.414v5.834a.442.442,0,0,0,.46.421.435.435,0,0,0,.452-.421V4.793A.434.434,0,0,0,10.037,4.379Zm0,7.5a.626.626,0,1,0,.679.62A.65.65,0,0,0,10.037,11.882Z",
    transform: "translate(-0.004)",
    fill: "#ff6a65"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarningCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warningCheck.8e21dd0a.svg";
export { ForwardRef as ReactComponent };